<template>
  <v-container fill-height fluid style="margin-top: -10px;">

  <!--v-img
      alt="VOYO Logo"
      class="shrink mr-5"
      contain
      :src="require('@/assets/consents/voyo_image.jpg')"
      transition="scale-transition"
      style="position: absolute; z-index: 0"
    /-->

    <v-row class="text-center" justify="center">
        <v-col cols="12" style="max-width: 780px;">

            <div class="d-none d-sm-flex" style="height:64px;"></div>

            <div class="text-center d-none d-sm-flex" justify="center" style="border-bottom: 1px solid rgb(255,255,255,0.3);">
              <div>
                <v-img
                  alt="VOYO Logo"
                  class="shrink mr-5 pb-5"
                  contain
                  :src="consents.logoUrl"
                  transition="scale-transition"
                  style=""
                  width="125"
                  height="125"
                />
              </div>
              <div style="float: left;">
                <p class="mt-2 mb-1 heading1">{{ consents.title }} <!--{{ print('PARTNER.VOYO.SSO_WEB.LAUNCH_APP_TITLE') }}--></p>
                <p class="mb-3 heading2">{{ consents.titleDescription }} <!--{{ print('PARTNER.VOYO.SSO_WEB.LAUNCH_APP_DESCRIPTION') }}--></p>
              </div>
            </div>
            <v-row class="text-center d-flex d-sm-none" justify="center" style="border-bottom: 1px solid rgb(255,255,255,0.3);">
              <v-col cols="12" sm="12">
                <v-img
                  alt="VOYO Logo"
                  class="shrink mr-5 pb-5"
                  contain
                  :src="consents.logoUrl"
                  transition="scale-transition"
                  width="125"
                  height="125"
                  style="float: left;"
                />
                <p class="mt-2 mb-3 heading1">{{ consents.title }}</p>
                <p class="mb-3 heading2">{{ consents.titleDescription }}</p>
              </v-col>
            </v-row>

            <v-row v-for="(consent,consentidx) in consents.consentDefinitions" :key="consentidx" style="border-bottom: 1px solid rgb(255,255,255,0.3);" class="ml-0 mr-0">
              <v-col class="consent_checkbox" cols="2" sm="1">
                <v-checkbox
                    :color="tenantColor"
                    :value="consent.name"
                    hide-details
                    class="mt-0"
                    v-model="confirmed"
                    :checked="true"
                    style="zoom : 2;"
                    @change="check()"
                ></v-checkbox>
              </v-col>
              <v-col class="consent_description" cols="10" sm="11">
                <span v-html="parseURLinString(consent.consentText)"></span><!--({{consent.mandatory ? 'povinné' : 'voliteľné'}})-->
              </v-col>
            </v-row>

            <v-row style="border-bottom: 1px solid rgb(255,255,255,0.3);" class="ml-0 mr-0">
              <v-col class="consent_checkbox" cols="2" sm="1">
                <v-icon class="mt-1" style="zoom : 2;">mdi-information-outline</v-icon>
              </v-col>
              <v-col class="consent_description" cols="10" sm="11">
                <span v-html="parseURLinString(consents.bottomDescription)"></span>
                <!--print('PARTNER.VOYO.SSO_WEB.INFO_APP_DESCRIPTION')-->
              </v-col>
            </v-row>

            <v-row style="background-color: red; border-radius: 5px; margin-top: 30px;" v-if="error !== ''">
                <v-col>
                    <p class="heading2 mb-0">{{error}}</p>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <p class="consent_description" v-html="parseURLinString(print('PARTNER.VOYO.SSO_WEB.LAUNCH_APP_MARKETING_OPTOUT'))"></p>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="last">
                    <v-btn block x-large
                      type="submit"
                      :color="tenantColor"
                      class="white--text"
                      @click="sendConsent"
                      :disabled="buttondisabled"
                      style="text-transform: none; color: #EBEBEB; font-size: 18px"
                    >
                        {{ print('PARTNER.VOYO.SSO_WEB.OPEN_APP_BTN') }}
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="first"><!-- class="d-none d-sm-flex" -->
                    <v-btn block x-large color="secondary" @click="redirectToPartner"
                      style="text-transform: none; color: #EBEBEB; font-size: 18px"
                    >
                        {{ print('PARTNER.VOYO.SSO_WEB.CLOSE_BTN') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>

  </v-container>
</template>

<style>
.heading1 {
    text-align: left;
    font-size: 30px;
    line-height: 1.2;
}
.heading2 {
    text-align: left;
    font-size: 18px;
    line-height: 1.2;
    letter-spacing: 0.7px;
}
.consent_checkbox {
    text-align: left;
    padding-top: 0px;
}
.consent_description {
    text-align: left;
    font-size: 16px;
    line-height: 1.2;
    letter-spacing: 0.7px;
}

.v-text-field {
    font-size: 1.5em;
    font-weight: 100;
}

.v-btn {
    text-transform: none;
    color: #EBEBEB;
    font-size: 1.5em !important;
    letter-spacing: normal;
}

</style>

<script>
  import { api } from "../main";
  import VueCookies from 'vue-cookies'

  export default {
    name: 'LogIn',
    data: () => ({
        consents: {},
        confirmed: [],
        error: '',
        lang: {
          'header_consent': {'SK': 'Spustenie Voyo', 'CZ': 'Spustenie Voyo (CZ)', 'EN': 'Getting Started with VOYO'}
        },
        //tenant: '',
        baseUrl: {},
        buttondisabled: false
    }),

    props: ['languagestrings', 'toperror'],

    computed: {
        language() {
            return VueCookies.get('language');
        },
        accessToken() {
            return VueCookies.get('accessToken');
        },
        tenant() {
            return VueCookies.get('tenant');
        },
        tenantColor() {
            return this.tenant == 'DIGI' ? '#0095DA' : '#EA0A8E'; // '#0095DA'
        },
        voyoicon() {
          return 'https://s2-h1-files.cdn.magio.tv/ui_images/CZ/cz-voyo-sticker.png'; //require('@/assets/consents/voyo_app_icon.png');
          //https://s2-h1-files.cdn.magio.tv/ui_images/CZ/cz-voyo-sticker.png
        }
    },

    methods: {

      goBack() {
          this.$router.go(-1)
      },

      redirectToPartner() {
          this.$router.push({ path: '/final', query: { result: 'false' } });
      },

      print(input_prop) {
          return api.print(this.languagestrings, input_prop);
      },

      check () {
        this.$nextTick(() => {
          var mandatoryfield = true;
          // VALIDATE MANDATORY CONSENT
          this.consents.consentDefinitions.forEach((defval) => {
            if(defval.mandatory == true) {
              if(!this.confirmed.includes(defval.name)) {
                mandatoryfield = false;
              }
            }
          });
          if(!mandatoryfield) {
            this.buttondisabled = true;
            return;
          }
          else {
            this.buttondisabled = false;
            return;
          }
        })
      },

      async loadConsents() {

        // HTTP REQUEST
        const options = {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.accessToken
          }
        };
        var res = await api.requestData(this.baseUrl[this.tenant] + '/template-consents?language=' + this.language, options);

        // REQUEST RESULTS ACTIONS
        if(Object.prototype.hasOwnProperty.call(res, 'status')) {
          if(res.status == 'ok') {
            this.consents = res.responseBody;
            //console.log(this.consents);
          }
          else {
            if(res.responseStatus == 'ECONNRESET') {
              this.error = 'Pripojenie na server zlyhalo.';
            }
            else {
              this.error = res.responseBody.error_description;
              if (res.responseStatus == '401') {
                setTimeout(() => {this.$router.push({ path: VueCookies.get('loginPath') })}, 3000);
              }
            }              
          }
        }
        else {
          this.error = 'Pripojenie na server zlyhalo.';
        }
      },

      async sendConsent() {
        this.buttondisabled = true;
        var mandatoryfield = true;
        // VALIDATE MANDATORY CONSENT
        this.consents.consentDefinitions.forEach((defval) => {
          if(defval.mandatory == true) {
            if(!this.confirmed.includes(defval.name)) {
              //console.log('ERROR: mandatory consent required');
              //this.error = 'Pre pokračovanie potvrďte povinné pole';
              mandatoryfield = false;
            }
          }
        });
        if(!mandatoryfield) {
          this.buttondisabled = false;
          return;
        }

        // CREATE POST DATA
        var data = {"consents": []};
        // add ACCEPTED CONSENTS
        this.confirmed.forEach((con) => {
          data.consents.push({"name": con, "value": true})
        });
        // add DENIED CONSENTS
        this.consents.consentDefinitions.forEach((defval) => {
          if(!this.confirmed.includes(defval.name)) {
            data.consents.push({"name": defval.name, "value": false})
          }
        })

        // HTTP REQUEST
        const options = {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.accessToken
          },
          body: JSON.stringify(data)
        };
        var res = await api.requestData(this.baseUrl[this.tenant] + '/consents', options);

        // REQUEST RESULTS ACTIONS
        if(Object.prototype.hasOwnProperty.call(res, 'status')) {
          if(res.status == 'ok') {
            this.$router.push({ path: '/allowpartner' })
          }
          else {
            if(res.responseStatus == 'ECONNRESET') {
              this.error = 'Pripojenie na server zlyhalo.';
            }
            else {
              this.error = res.responseBody.error_description;
              if (res.responseStatus == '401') {
                setTimeout(() => {this.$router.push({ path: VueCookies.get('loginPath') })}, 3000);
              }
            }              
          }
        }
        else {
          this.error = 'Pripojenie na server zlyhalo.';
        }
        this.buttondisabled = false;
      },

      waitForLoadingConsent(){
        this.baseUrl = api.getBaseUrl();
        if(typeof this.baseUrl === 'object' && this.baseUrl !== null) {
          if(Object.prototype.hasOwnProperty.call(this.baseUrl, this.tenant)) {
            if(typeof this.baseUrl[this.tenant] !== "undefined"){
              this.loadConsents();
            }
            else{
              setTimeout(this.waitForLoadingConsent, 250);
            }
          }
          else {
            //console.log('no prop', this.baseUrl);
            setTimeout(this.waitForLoadingConsent, 250);
          }
        } else {
          //console.log('no obj', this.baseUrl);
          setTimeout(this.waitForLoadingConsent, 250);
        }
      },

      parseURLString (text) {
        if (typeof text !== 'undefined') {
          if (text.includes('(https://www.')) {
              var hasHyperlink = true;
              var textBeforeLink = text.substring(0, text.indexOf('['));
              var textLinkName = text.slice(text.indexOf('[') + 1, text.lastIndexOf(']'));
              var textLink = text.slice(text.indexOf('(') + 1, text.lastIndexOf(')'));
              var textAfterLink = text.substring(text.indexOf(') ') + 1);
              return [hasHyperlink, textBeforeLink, textLinkName, textLink, textAfterLink];
          }
        }
        return [false, text, '', '', ''];
      },

      parseURLinString(text) {
          var hasHyperlink = false;
          var textLink = '';
          var textLinkName = '';
          var textBeforeLink = '';
          var textAfterLink = '';

          [hasHyperlink, textBeforeLink, textLinkName, textLink, textAfterLink] = this.parseURLString(text);
          return (hasHyperlink && (textBeforeLink + '<a href="' + textLink + '" target="_blank">' + textLinkName + '</a>' + textAfterLink)) || (!hasHyperlink && textBeforeLink);
      }

    },

    created: async function(){
        //this.tenant = VueCookies.get('tenant');
        this.waitForLoadingConsent();

        //console.log('VueCookies', VueCookies.keys());
        //console.log(VueCookies.get('vopConsent'));
        if(VueCookies.get('vopConsent') == 'true') {
          this.confirmed.push('VOP_CONSENT');
          this.buttondisabled = false;
        }
        else {
          this.buttondisabled = true;
        }
    }
  }
</script>
